import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/database'
import 'firebase/auth'
import 'firebase/storage'

const config = {
    apiKey: "AIzaSyDdvDtFDz3qTHWYg_B5-5GjtS8JOvaXv_U",
    authDomain: "la-hustle.firebaseapp.com",
    databaseURL: "https://la-hustle.firebaseio.com",
    projectId: "la-hustle",
    storageBucket: "la-hustle.appspot.com",
    messagingSenderId: "761784795938"
  };

firebase.initializeApp(config);

const firebaseDB = firebase.database();
const firebaseUsers = firebaseDB.ref("Users");
const firebasePosts = firebaseDB.ref("Posts");
//const firebaseMatches = firebaseDB.ref('matches');
//const firebasePromotions = firebaseDB.ref('promotions');
//const firebaseTeams = firebaseDB.ref('teams');
//const firebasePlayers = firebaseDB.ref('players');

export {
    firebase,
    firebaseUsers,
    firebasePosts,
    //firebaseMatches,
    //firebasePromotions,
    //firebaseTeams,
    //firebasePlayers,
    firebaseDB
}


// WEBPACK FOOTER //
// ./src/firebase.js